import { formatarStatusFinanceiro } from "@/modules/financeiro-obras";

/** Textos e formatos de apresentação das fichas financeiras da obra (HU 2679). */

export const FICHAS_NO_VALUE = "—";

const NUMERO_BR = new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 2, useGrouping: false });
const MOEDA_BR = new Intl.NumberFormat("pt-BR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** `2026-10-10T14:30:00` → `10/10/2026 14:30`; data inválida vira "—". */
export function formatCriadoEm(iso: string): string {
  const date = new Date(iso);
  if (!iso || Number.isNaN(date.getTime())) return FICHAS_NO_VALUE;

  const pad = (value: number) => String(value).padStart(2, "0");
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

/** Listagem das fichas: `2026-10-10T14:30:00` → `10/10/2026 - 14:30`. */
export function formatCriadoEmLista(iso: string): string {
  return formatCriadoEm(iso).replace(" ", " - ");
}

/** `2026-10-10T14:30:00` → `10/10/2026` (data de elaboração). */
export function formatElaboradoEm(iso: string): string {
  const completo = formatCriadoEm(iso);
  return completo === FICHAS_NO_VALUE ? completo : completo.slice(0, 10);
}

/** `2026-10-10` → `10/10/2026`; formato inesperado vira "—". */
export function formatDataBr(isoDate: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(isoDate);
  return match ? `${match[3]}/${match[2]}/${match[1]}` : FICHAS_NO_VALUE;
}

/** `4184.88` → `4184,88` (sem separador de milhar), com sufixo opcional; `null` vira "—". */
export function formatNumero(value: number | null, sufixo = ""): string {
  return value === null ? FICHAS_NO_VALUE : `${NUMERO_BR.format(value)}${sufixo}`;
}

/** Valor monetário sem símbolo, como na tabela de custos: `1300000` → `1.300.000,00`. */
export function formatValorMonetario(value: number): string {
  return MOEDA_BR.format(value);
}

/** Descrição do status FEL; código fora do cadastro aparece como veio e ausente vira "—". */
export function rotuloStatusFel(statusFel: string | null): string {
  if (!statusFel) return FICHAS_NO_VALUE;
  return formatarStatusFinanceiro({ codigo: statusFel });
}
